import $ from 'jquery';
import { gsap } from 'gsap';
import domReady from '@wordpress/dom-ready';

class ListFilter {
  constructor(params) {
    this.$cache = {};
    this.$cache.main = params.target;

    this.isOpen = false;
    this.hasTitle = false;

    this.initCache();
    this.initEventConst();
    this.registerEvent();
  }

  initCache() {
    this.$cache.opener = this.$cache.main.find('.filter-opener');
    this.$cache.openerCTA = this.$cache.opener.find('.filter-opener-actions');
    this.$cache.content = this.$cache.main.find('.filter-wrapper');
    this.$cache.contentInner = this.$cache.content.find(
      '.filter-wrapper-inner'
    );
    this.$cache.filterHead = this.$cache.contentInner.find('.filter-head');
    this.$cache.closerCTA = this.$cache.filterHead.find(
      '.filter-closer .cross'
    );

    this.hasTitle = this.$cache.main.find('.opener-with-title').length > 0;
  }

  initEventConst() {
    this.openEvent = (e) => this.open(e);
    this.closeEvent = (e) => this.close(e);
  }

  registerEvent() {
    this.$cache.openerCTA.on('click', this.openEvent);
    this.$cache.closerCTA.on('click', this.closeEvent);
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;

    this.$cache.main.addClass('is-open');

    const h = this.$cache.contentInner.outerHeight();
    const tl = gsap.timeline({ paused: true });

    if (this.hasTitle) {
      tl.to(
        this.$cache.main,
        { duration: 0.5, height: h + 100, force3D: true, ease: 'quad.out' },
        0.25
      );
      tl.fromTo(
        this.$cache.contentInner,
        { y: h / 4 + 150 },
        { duration: 0.6, y: h / 6 + 100, ease: 'circ.out' },
        0.3
      );
      tl.fromTo(
        this.$cache.contentInner,
        { opacity: 0 },
        { duration: 0.5, opacity: 1, ease: 'quad.out' },
        0.3
      );
    } else {
      tl.to(
        this.$cache.openerCTA,
        { duration: 0.5, opacity: 0, ease: 'expo.out' },
        0
      );
      tl.to(
        this.$cache.main,
        { duration: 0.5, height: h, force3D: true, ease: 'quad.out' },
        0.25
      );
      tl.fromTo(
        this.$cache.contentInner,
        { y: 50 },
        { duration: 0.6, y: 0, ease: 'circ.out' },
        0.3
      );
      tl.fromTo(
        this.$cache.contentInner,
        { opacity: 0 },
        { duration: 0.5, opacity: 1, ease: 'quad.out' },
        0.3
      );
    }

    tl.play();
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;

    const hOpener = this.$cache.opener.outerHeight();
    const tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.$cache.main.removeClass('is-open');
      },
    });

    tl.to(
      this.$cache.contentInner,
      { duration: 0.4, opacity: 0, ease: 'expo.out' },
      0
    );
    tl.to(
      this.$cache.main,
      { duration: 0.7, height: hOpener, ease: 'quad.out' },
      0.1
    );

    if (!this.hasTitle) {
      tl.to(
        this.$cache.openerCTA,
        { duration: 0.5, opacity: 1, ease: 'cubic.out' },
        0.3
      );
    }

    tl.play();
  }

  resize() {
    const bpLastValue = window.bp.lastValue;
    const bpValue = window.bp.value;

    if (bpLastValue !== bpValue || 'xs' === bpValue) {
      if (this.isOpen) {
        this.$cache.main.height(this.$cache.contentInner.outerHeight());
      }
    }
  }
}

export default ListFilter;

domReady(() => {
  $('[data-component="listFilter"]').each(function () {
    new ListFilter({ target: $(this) });
  });
});
